import styled from "styled-components";

import FallbackImage from "components/global/FallbackImage";

export const SportsPrimaryButton = styled.button.attrs({
  className:
    "inline-flex items-center gap-2 rounded-2xl bg-[var(--brand-accent)] px-4 py-3 text-sm font-medium text-white transition hover:bg-[var(--brand-accent-deep)]",
})``;

export const SportsInfoRow = styled.div.attrs({ className: "flex min-w-0 items-center gap-3" })``;

export const SportsThumbnailFrame = styled.div.attrs({ className: "relative shrink-0" })``;

export const SportsThumbnailImage = styled(FallbackImage).attrs({
  className: "h-11 w-11 rounded-2xl",
})``;

export const SportsIconBadge = styled.span.attrs({
  className:
    "absolute -bottom-1 -right-1 inline-flex h-6 w-6 items-center justify-center rounded-full border border-[rgba(255,255,255,0.7)] text-white",
})<{ $accent: string; $glow: string }>`
  background: ${({ $accent }) => $accent};
  box-shadow: 0 14px 26px ${({ $glow }) => $glow};
`;

export const SportsLabelText = styled.p.attrs({
  className: "font-medium text-[var(--brand-ink)]",
})``;

export const SportsMetaText = styled.p.attrs({ className: "text-xs text-[var(--brand-muted)]" })``;

export const SportsGridLayout = styled.div.attrs({
  className: "grid gap-3 md:grid-cols-[1.2fr_0.7fr_0.7fr]",
})``;

export const SportsSectionToolbar = styled.div.attrs({
  className: "grid w-full gap-3 md:grid-cols-[1.2fr_0.7fr_0.7fr] xl:min-w-[720px]",
})``;

export const SportsFeaturedSectionWrap = styled.div.attrs({
  className: "mb-8",
})``;

export const SportsFeaturedGrid = styled.div.attrs({
  className: "grid gap-4 md:grid-cols-2 xl:grid-cols-3",
})``;

export const SportsFeaturedCard = styled.button.attrs({
  className:
    "flex w-full flex-col gap-3 rounded-[22px] border border-[var(--brand-border)] bg-[rgba(255,255,255,0.03)] p-4 text-left transition hover:-translate-y-0.5 hover:border-[var(--brand-highlight)] hover:bg-[rgba(240,191,86,0.06)] focus:outline-none focus:ring-2 focus:ring-[rgba(240,191,86,0.35)]",
})``;

export const SportsFeaturedTitle = styled.p.attrs({
  className: "font-medium text-[var(--brand-ink)]",
})``;

export const SportsFeaturedMeta = styled.div.attrs({
  className: "flex items-center gap-4 text-xs text-[var(--brand-muted)]",
})``;

export const SportsFeaturedBadge = styled.span.attrs({
  className:
    "inline-flex w-fit rounded-full border border-[rgba(240,191,86,0.28)] bg-[rgba(240,191,86,0.08)] px-2.5 py-1 text-xs font-medium uppercase tracking-[0.16em] text-[var(--brand-highlight)]",
})``;

export const SportsCardGrid = styled.div.attrs({
  className: "grid gap-3 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 3xl:grid-cols-6",
})``;

export const SportsListingCard = styled.article.attrs({
  className:
    "group relative flex h-full flex-col gap-3 overflow-hidden rounded-[18px] border border-[rgba(255,255,255,0.06)] bg-[linear-gradient(180deg,rgba(255,255,255,0.04),rgba(255,255,255,0.025))] p-3 transition hover:-translate-y-0.5 hover:border-[rgba(240,191,86,0.22)] hover:shadow-[0_16px_32px_rgba(0,0,0,0.18)]",
})`
  backdrop-filter: blur(10px);
`;

export const SportsCardHeader = styled.div.attrs({
  className: "flex items-start justify-between gap-3",
})``;

export const SportsCardIdentity = styled.div.attrs({
  className: "min-w-0 space-y-0.5",
})``;

export const SportsCardSubtext = styled.p.attrs({
  className: "truncate text-xs uppercase tracking-[0.14em] text-[var(--brand-muted)]",
})``;

export const SportsCardStatusWrap = styled.div.attrs({
  className: "shrink-0",
})``;

export const SportsCardActionRow = styled.div.attrs({
  className: "mt-auto flex items-center justify-between gap-2 pt-1",
})``;

export const SportsCardOpenButton = styled.button.attrs({
  className:
    "inline-flex min-h-[34px] items-center justify-center rounded-full border border-[rgba(240,191,86,0.18)] bg-transparent px-3 py-1.5 text-xs font-medium uppercase tracking-[0.14em] text-[var(--brand-highlight)] transition hover:border-[rgba(240,191,86,0.28)] hover:text-[var(--brand-ink)]",
})``;

export const SportsCardActionsGroup = styled.div.attrs({
  className: "flex items-center gap-1.5",
})``;

export const SportsCardIconButton = styled.button.attrs({
  className:
    "inline-flex h-8 w-8 items-center justify-center rounded-full border border-[rgba(255,255,255,0.08)] bg-transparent text-[var(--brand-muted)] transition hover:border-[rgba(240,191,86,0.2)] hover:bg-[rgba(240,191,86,0.08)] hover:text-[var(--brand-ink)]",
})``;

export const SportsCardSkeletonGrid = styled.div.attrs({
  className: "grid gap-4 md:grid-cols-2 xl:grid-cols-3",
})``;

export const SportsCardSkeleton = styled.div.attrs({
  className:
    "animate-pulse rounded-[24px] border border-[var(--brand-border)] bg-[rgba(255,255,255,0.03)] p-4",
})``;

export const SportsCardSkeletonBlock = styled.div`
  border-radius: 1rem;
  background: rgba(255, 255, 255, 0.06);
`;

export const SportsFieldInput = styled.input.attrs({ className: "brand-input" })``;

export const SportsFieldSelect = styled.select.attrs({ className: "brand-input" })``;

export const SportsPaginationBar = styled.div.attrs({
  className:
    "mt-5 flex flex-col gap-3 rounded-[20px] border border-[var(--brand-border)] bg-[rgba(255,255,255,0.03)] px-4 py-3 text-[13px] text-[var(--brand-muted)] sm:flex-row sm:items-center sm:justify-between",
})``;

export const SportsPaginationText = styled.p.attrs({
  className: "text-[13px] text-[var(--brand-muted)]",
})``;

export const SportsPaginationControls = styled.div.attrs({
  className: "flex items-center gap-3 self-end sm:self-auto",
})``;

export const SportsPaginationButton = styled.button.attrs({
  className:
    "inline-flex min-h-[40px] items-center justify-center rounded-2xl border border-[var(--brand-border)] bg-[rgba(255,255,255,0.04)] px-3 py-2 text-sm text-[var(--brand-ink)] transition hover:border-[var(--brand-highlight)] hover:bg-[rgba(240,191,86,0.08)] disabled:cursor-not-allowed disabled:opacity-45",
})``;

export const SportsPaginationLabel = styled.span.attrs({
  className: "font-anonymous text-xs uppercase tracking-[0.18em] text-[var(--brand-muted)]",
})``;
